import React from 'react';
import { useLocation } from 'react-router-dom';
import DoctorManagement from '../components/business/DoctorManagement';
import DoctorDetails from '../components/business/doctor-management/DoctorDetails';

export const DoctorManagementCtx = React.createContext({});

function DoctorManagementPageProvider(props) {
  const ctx = {
  };
  return (
    <DoctorManagementCtx.Provider value={ ctx }>
      {props.children}
    </DoctorManagementCtx.Provider>
  );
}

function DoctorManagementPage() {
  const location = useLocation();

  const { search } = location;
  const params = new URLSearchParams(search);
  const id = params.get('id');

  return (
    <DoctorManagementPageProvider>
      { id ? <DoctorDetails id={ id } /> : <DoctorManagement />}
    </DoctorManagementPageProvider>
  );
}

export default DoctorManagementPage;
